import { Card } from "@/core/components/ui/card";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export const BookingsTimeseriesChartError = (props: {
  error: Error | null;
}) => {
  const [t] = useTranslation(["dashboard"]);

  return (
    <Card className="bg-card border border-border shadow-sm flex-1 h-[200px] p-4">
      <div className="flex items-center justify-between px-6 h-[56px]">
        <h2 className="text-base font-normal text-foreground">
          {t("dashboard-bookings-timeseries-title")}
        </h2>
        <ArrowUpRight className="w-6 h-6 text-foreground" />
      </div>

      <hr />

      <div className="py-6">
        <p className="text-sm text-red-600 text-center">
          {props.error
            ? t("dashboard-error-loading-data", "Erro ao carregar dados")
            : t("dashboard-no-data-available", "Sem dados disponíveis")}
        </p>
      </div>
    </Card>
  );
};
